import { render, staticRenderFns } from "./ProjectsMerge.vue?vue&type=template&id=0d467c1b&"
import script from "./ProjectsMerge.vue?vue&type=script&lang=js&"
export * from "./ProjectsMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports